<div class="mb-3">
    <button type="button" class="btn btn-sm mr-3 {{ taskFilters.length? 'btn-outline-success' : 'btn-outline-primary' }}" [attr.aria-expanded]="!isFilterCollapsed" (click)="filter.toggle()">
        <i class="fa fa-fw fa-filter" aria-hidden="true"></i>
        <span>Filter</span>
    </button>
</div>

<div #filter="ngbCollapse" [(ngbCollapse)]="isFilterCollapsed">
    <div class="pt-3 pb-3">
        <app-run-task-filter [(config)]="taskFilterConfig" (filtersChange)="taskFilters = $event"></app-run-task-filter>
    </div>
</div>

<ngx-datatable
    [rows]="tasks"
    [rowIdentity]="rowIdentity"
    [selected]="updatedSelection"
    (select)="onSelect($event)"
    [displayCheck]="displayCheck"
    [count]="totalTaskCount"
    [externalPaging]="true"
    [offset]="currentPage"
    (page)="onSetPage($event)"
    [limit]="tasksPerPage"
    [loadingIndicator]="loadingPages"
    class="material run-task-search"
    [scrollbarV]="false"
    [scrollbarH]="true"
    [rowHeight]="50"
    [headerHeight]="30.5"
    [footerHeight]="50"
    selectionType="checkbox"
    columnMode="force">

    <ngx-datatable-column
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [checkboxable]="true"
        [width]="30">
    </ngx-datatable-column>

    <ngx-datatable-column name="Control Number" prop="connote.control_no"></ngx-datatable-column>

    <ngx-datatable-column name="Customer" prop="connote.customer">
        <ng-template ngx-datatable-cell-template let-customer="value">
            <ng-container *ngIf="customer">{{ customer.company_name }}</ng-container>
            <span *ngIf="!customer" class="font-italic text-muted">None</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Action" prop="run_action">
        <ng-template ngx-datatable-cell-template let-action="value">{{ action?.label | titlecase }}</ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location">
        <ng-template ngx-datatable-cell-template let-location="value">
            <ng-container *ngIf="location; else noLocation">{{ location | readLocation }}</ng-container>
            <ng-template #noLocation><span class="font-italic text-muted">No location info</span></ng-template>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Planned Start" prop="start_datetime_utc">
        <ng-template ngx-datatable-cell-template let-datetime="value">{{ datetime | date: 'medium' }}</ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Planned End" prop="end_datetime_utc">
        <ng-template ngx-datatable-cell-template let-datetime="value">{{ datetime | date: 'medium' }}</ng-template>
    </ngx-datatable-column>
    
</ngx-datatable>
